import { render, staticRenderFns } from "./PractionerDashboard.vue?vue&type=template&id=52abb1b8&scoped=true"
import script from "./PractionerDashboard.vue?vue&type=script&lang=js"
export * from "./PractionerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52abb1b8",
  null
  
)

export default component.exports